import { supabase } from './supabaseClient';

export async function trackLoginEvent(userId: string, accountId?: string) {
  try {
    // If no accountId provided, try to get it from the user's account
    if (!accountId) {
      const { data: userAccount } = await supabase
        .from('accounts')
        .select('id')
        .eq('owner_id', userId)
        .single();
      
      if (userAccount) {
        accountId = userAccount.id;
      }
    }

    // Only log if we have both user and account IDs
    if (userId && accountId) {
      const { error } = await supabase
        .from('app_usage_logs')
        .insert({
          user_id: userId,
          account_id: accountId,
          activity_type: 'login',
          created_at: new Date().toISOString(),
          metadata: {
            timestamp: new Date().toISOString(),
            user_agent: navigator.userAgent,
            platform: navigator.platform
          }
        });

      if (error) {
        console.error('Failed to track login event:', error);
      } else {
        console.log('Login event tracked successfully');
      }
    }
  } catch (error) {
    console.error('Error tracking login:', error);
  }
}